import request from '../utils/request'

export function getAllergens() {
    return request({
        url: '/allergens',
        method: 'get'
    })
}
